import Chip from '@sats-group/ui-lib/react/chip';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { Categories as Props } from './categories.types';

const Categories: React.FunctionComponent<Props> = ({ categories, title }) => (
  <div className="categories">
    <Text
      className="categories__title"
      elementName="h2"
      theme={Text.themes.normal}
      inline
      size={Text.sizes.headline3}
    >
      {title}
    </Text>
    <div className="categories__links">
      {categories.map((category, index) => (
        <Chip {...category} key={`${category.text}-${index}`} />
      ))}
    </div>
  </div>
);

export default Categories;
